import useClickListener from "../../utils/hooks/useClickListener"
import { containsValidTargetClass } from "./DatalayerMethods"

const DatalayerPromoBanner = props => {
  const datalayerPromoBannerHandler = event => {
    const validClasses = [
      "t2-promotion-banner__button",
      "t2-promotion-banner__button--cta",
      "t2-promotion-banner__button--close",
      "t2-promotion-banner__close-button-icon",
    ]
    if (containsValidTargetClass(validClasses, event?.target?.classList)) {
      const header = event?.target
        ?.closest(".t2-promotion-banner")
        .querySelector(".t2-promotion-banner__header")
      const buttonText =
        event?.target?.textContent || event?.target?.innerText || null
      const href = event.target.getAttribute("href") || null

      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: "banner_click",
        click_label: buttonText,
        click_url: href,
        click_helper_text: buttonText,
        click_label_english: buttonText,
        banner_header_value: header?.innerText,
      })
    }
  }
  // add handler if relevant listener elem exists
  let query = ""
  if (typeof window !== "undefined" && typeof document !== "undefined") {
    query =
      document?.querySelectorAll(
        ".ter-button, .t2-button, .t2-spbutton__wrap, .t2-search-button"
      ).length > 0
  }
  useClickListener(datalayerPromoBannerHandler, query)
}

export default DatalayerPromoBanner
